import Vue from 'vue'
import Vuex from 'vuex'
import bus from '../utils/bus'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    joinVisible: false,
    payModal: false,
    createVisible: false,
    userInfo: {
      companyList: [],
      type: 0
    },
    adminMenus: [],
    signerArr: [],
    newSignerArr: [],
    dateArr: [],
    newDateArr: [],
    signatureArr: [],
    newSignatureArr: [],
    ridingArr: [],
    newRidingArr: [],
    signJsonArr: [],
    currentSignerImg: '',
    currentSigner: {},
    imgWidth: 0,
    imgHeight: 0,
    dateImgHash: '',
    dateImgUrl: '',
    currentWidget: {
      x: 0,
      y: 0
    },
    urlList: [],
    signId: '',
    signJson: [],
    currentSigPic: '',
    createSuccess: false,
    showSelect: false,
    showSigner: false,
    createPaySuccess: false,
    signatureModal: false,
    ratio: 0,
    loadingStatus: false,
    pdfData: []
  },
  mutations: {
    setPdfData (state, pdfData) {
      state.pdfData = pdfData
    },
    setUser (state, userInfo) {
      state.userInfo = userInfo
    },
    setCreate (state, flag) {
      state.createSuccess = flag
    },
    setShowSelect (state, flag) {
      state.showSelect = flag
    },
    setShowSigner (state, flag) {
      state.showSigner = flag
    },
    setUrlList (state, list) {
      state.urlList = list
    },
    setSignJson (state, json) {
      state.signJson = json
    },
    setSignJsonArr (state, json) {
      state.signJsonArr = json
    },
    setCurrentWidget (state, widget) {
      state.currentWidget = widget
    },
    setCurrentSigner (state, signer) {
      state.currentSigner = signer
    },
    setSignatureModal (state, flag) {
      state.signatureModal = flag
    },
    setImgHeight (state, height) {
      state.imgHeight = height
    },
    setImgWidth (state, width) {
      state.imgWidth = width
    },
    setDateImgUrl (state, img) {
      state.dateImgUrl = img
    },
    setDateImgHash (state, hash) {
      state.dateImgHash = hash
    },
    setCurrentSignerImg (state, signer) {
      state.currentSignerImg = signer
    },
    setSignerArr (state, signerArr) {
      state.signerArr = signerArr
    },
    setnewSignerArr (state, signerArr) {
      state.newSignerArr = signerArr
    },
    setDateArr (state, dateArr) {
      state.dateArr = dateArr
    },
    setnewDateArr (state, dateArr) {
      state.newDateArr = dateArr
    },
    setSignatureArr (state, signatureArr) {
      state.signatureArr = signatureArr
    },
    setnewSignatureArr (state, signatureArr) {
      state.newSignatureArr = signatureArr
    },
    setRidingArr (state, ridingArr) {
      state.ridingArr = ridingArr
    },
    setnewRidingArr (state, ridingArr) {
      state.newRidingArr = ridingArr
    },
    showJoin (state) {
      state.joinVisible = true
    },
    hideJoin (state) {
      state.joinVisible = false
    },
    setSignId (state, id) {
      state.signId = id
    },
    setCurrentSigPic (state, pic) {
      state.currentSigPic = pic
    },
    createJoin (state) {
      state.createVisible = true
    },
    hideCreateJoin (state) {
      state.createVisible = false
    },
    setAdminMenus (state, menus) {
      state.adminMenus = menus
    },
    setRatio (state, ratio) {
      state.ratio = ratio
    },
    setPayModal (state, flag) {
      state.payModal = flag
    },
    setCreatePaySuccess (state, flag) {
      state.createPaySuccess = flag
    },
    setLoadingStatus (state, status) {
      state.loadingStatus = status
    }
  },
  actions: {

  }
})

export default store
